var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPix
    ? _c(
        "ConfigBox",
        {
          attrs: {
            title: _vm.$t("account.settings.pix.title"),
            callback: _vm.savePixConfig,
            loading: _vm.accountLoading,
            hideEditButton: !_vm.permissionIsEnabled(
              "settings.payments.pix:edit"
            ),
          },
          on: {
            cancelEdit: function ($event) {
              return _vm.resetObject(_vm.pix, _vm.paymentMethods.pix)
            },
          },
        },
        [
          _c(
            "template",
            { slot: "content" },
            [
              _vm.modalPix.createOrDeleteIsSuccess
                ? _c("emd-alert", {
                    attrs: {
                      variant: "success",
                      title: _vm.modalPix.createOrDeleteAlertMessage,
                    },
                    on: { cancel: _vm.closePixCreateOrDeleteSuccessAlert },
                  })
                : _vm._e(),
              _c("div", { staticClass: "emd-panel" }, [
                _vm.canEditKeyPix
                  ? _c("div", { staticClass: "emd-panel__section" }, [
                      _c("div", { staticClass: "emd-panel__block" }, [
                        _c("div", { staticClass: "el-chunk" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _color_default _type_caption",
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("pix.key")) + " ")]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "emd-panel__block" }, [
                        _c(
                          "div",
                          { staticClass: "el-chunk" },
                          [
                            _c(
                              "emd-alert",
                              {
                                staticClass: "eu-mt_0 eu-mb_5",
                                attrs: {
                                  variant: "info",
                                  noClose: "",
                                  autoclose: false,
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "emd-text _color_info _type_caption eu-mb_1",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("pix.alert.title")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("p", { staticClass: "emd-text" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("pix.alert.warning")) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            ),
                            _c(
                              "p",
                              { staticClass: "emd-text _type_caption eu-mb_2" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("pix.recipient")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "eu-flex eu-column eu-row_md" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "eu-flex-item eu-basis_3" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "emd-label",
                                        attrs: { for: "status" },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("pix.name")))]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.dataClientPix.name)),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "eu-flex-item eu-basis_3" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "emd-label",
                                        attrs: { for: "status" },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("pix.document")))]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.dataClientPix.documentNumber)
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm.pix.key
                              ? _c(
                                  "div",
                                  { staticClass: "eu-display_flex eu-mt_5" },
                                  [
                                    _c("emerald-icon", {
                                      attrs: { icon: "check" },
                                    }),
                                    _c(
                                      "p",
                                      { staticClass: "emd-text eu-ml_2" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("pix.key-created-p1")
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.dataClientPix.name)
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("pix.key-created-p2")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showCreateKeyButton
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "emd-btn _color_primary eu-my_5",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "onToggleModalPix",
                                          "createKeyIsOpen"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("pix.create-key")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.showDeleteKeyButton
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "emd-btn _color_danger eu-my_5",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "onToggleModalPix",
                                          "deleteKeyIsOpen"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("pix.delete-key")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "emd-panel__section" }, [
                  _c("div", { staticClass: "emd-panel__block" }, [
                    _c("div", { staticClass: "el-chunk" }, [
                      _c(
                        "h2",
                        {
                          staticClass: "emd-text _color_default _type_caption",
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("pix.config")) + " ")]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "emd-panel__block" }, [
                    _c("div", { staticClass: "el-chunk" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "status" },
                          },
                          [_vm._v(_vm._s(_vm.$t("pix.status")))]
                        ),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enabledPix" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pix.enabled,
                                  expression: "pix.enabled",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: {
                                checked: "checked",
                                type: "checkbox",
                                id: "enabledPix",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.pix.enabled)
                                  ? _vm._i(_vm.pix.enabled, null) > -1
                                  : _vm.pix.enabled,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.pix.enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.pix,
                                          "enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.pix,
                                          "enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.pix, "enabled", $$c)
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(_vm._s(_vm.$t("pix.active"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "el-chunk" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c("label", { staticClass: "emd-label _required" }, [
                          _vm._v(_vm._s(_vm.$t("pix.gateway"))),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "emd-select",
                            attrs: { id: "gatewayPix" },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pix.gateway,
                                    expression: "pix.gateway",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.pix,
                                      "gateway",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.transactionalModel,
                                function (gateway, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: gateway.key },
                                    },
                                    [_vm._v(" " + _vm._s(gateway.value) + " ")]
                                  )
                                }
                              ),
                              0
                            ),
                            _c("div", { staticClass: "emd-select__arrow" }),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }